import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
  content: {
    background: '#ffff',
    border: '1px solid #D9D9D9',
    width: '100%',
  },
  image: {
    width: 64,
    height: 58,
    backgroundColor: '#e6e6e6',
    borderRadius: 4,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: '1px solid #e4e4e4',
    [theme.breakpoints.down('sm')]: {
      margin: '0 auto',
    },
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.primary.main,

    '& span': {
      display: 'block',
      color: '#666',
      fontSize: 14,
      fontWeight: 400,

      '& a': {
        color: theme.palette.primary.main,
      },
    },
  },
  defaultText: {
    color: '#596375',
    fontSize: 13,
    fontWeight: 500,

    '&.--toUpper': {
      textTransform: 'uppercase',
    },
  },

  options: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',

    '& svg': {
      width: 48,
      fill: '#666',
      cursor: 'pointer',
      padding: 8,
    },
  },
  notfound: {
    width: '100%',
    textAlign: 'center',
    fontSize: 14,
    color: '#969696',
    padding: '16px 0',
  },
  colImg: {
    width: 72,
  },
  product: {
    '& span': {
      display: 'block',
    },
  },
  quickviewDataBasic: {
    '& .image': {
      width: '100%',
      maxWidth: 120,
      margin: '0 auto',
      height: 108,
      borderRadius: 4,
      backgroundColor: '#f1f1f1',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },

    '& .info': {
      '& h2': {
        fontSize: 17,
        marginBottom: 16,
      },

      '& span.status': {
        color: '#027102',
        display: 'block',
        fontSize: 14,
        fontWeight: 400,
        textTransform: 'uppercase',
      },

      // infoproduto head
      '& .producer': {
        fontWeight: 400,
        fontSize: 15,
        color: theme.palette.primary.dark,

        '& .data': {
          display: 'block',
          color: '#969696',
        },
      },

      // fisico head
      '& .tracking': {
        '& .data': {
          fontSize: 15,
          color: theme.palette.primary.dark,

          '& span': {
            color: '#969696',
          },
        },
      },
    },
  },
  tableStatus: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: '0.65rem',
    padding: '0 !important',
    borderRadius: 6,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    zIndex: 1,
    '&.--1': {
      background: '#009358',
    },

    '&.--9': {
      background: '#009358',
    },

    '&.--10': {
      background: '#009358',
    },

    '&.--2': {
      background: '#2d86ca',
    },

    '&.--3': {
      background: '#dc3f53',
    },

    '&.--4': {
      background: '#dc3f53',
    },

    '&.--7': {
      background: '#fabb0a',
    },

    [theme.breakpoints.down('md')]: {
      width: '0.75rem',
      height: '0.75rem',
      top: '50%',
      left: '50%',
      borderRadius: 30,
      transform: 'translate3d(-50%, -50%, 0)',
    },
  },
  tableStatusHistory: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: '0.65rem',
    padding: '0 !important',
    borderRadius: 6,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    zIndex: 1,

    '&.paid, &.negociated': {
      backgroundColor: theme.palette.success.main,
    },
    '&.refunded, &.waiting_refund': {
      backgroundColor: theme.palette.error.main,
    },
    '&.canceled, &.duplicated, &.expired': {
      backgroundColor: theme.palette.primary.light,
    },
    '&.open': {
      backgroundColor: '#2d86ca',
    },
    '&.analysing': {
      backgroundColor: '#2d86ca',
    },
    '&.recovering, &.waiting_payment': {
      backgroundColor: '#fabb0a',
    },
    [theme.breakpoints.down('md')]: {
      width: '0.75rem',
      height: '0.75rem',
      top: '50%',
      left: '50%',
      borderRadius: 30,
      transform: 'translate3d(-50%, -50%, 0)',
    },
  },
  tableAction: {
    cursor: 'pointer',
    '&:hover': {
      color: '#192542',
    },
  },
  sender: {
    width: '100%',

    '& h3': {
      display: 'block',
      fontSize: 17,
      marginBottom: 12,
      textTransform: 'uppercase',
      fontWeight: 400,
    },

    '& .data': {
      width: '100%',
      marginBottom: 4,
      color: '#969696',
      fontSize: 15,

      '&:last-child': {
        marginBottom: 0,
      },

      '& span': {
        fontWeight: 500,
        display: 'inline-block',
        color: '#000000d9',
      },
    },
  },
  yes: {
    backgroundColor: '#d2ebd3',
    color: '#4caf50',
    padding: 10,
    fontWeight: 500,
    maxWidth: '45px',
    borderRadius: 5,
  },
  no: {
    backgroundColor: '#ddd',
    color: '#78909c',
    padding: 10,
    fontWeight: 500,
    maxWidth: '45px',
    borderRadius: 5,
  },
  expired: {
    color: 'red',
    display: 'flex',
    alignItems: 'center',
  },
  approve: {
    color: '#009358',
  },
  repprove: {
    color: '#dc3f53',
  },
  icon: { paddingRight: 10 },
}));

export default useStyle;
